import type { ApiClientOptions } from "./client";
import { createApiClient } from "./client";

export interface NewsItem {
  id: string;
  title: string;
  description: string;
  is_published: boolean;
  gradient: string | null;
  action_url: string | null;
  created_at: string;
  updated_at: string;
}

export function createNewsApi(options: ApiClientOptions) {
  const api = createApiClient(options);

  return {
    list: () => api.get<NewsItem[]>("/api/news"),
  };
}
